export class GlueDatabaseSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "tablesMode",
            "baseName": "tablesMode",
            "type": "GlueTablesMode",
            "format": ""
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GlueDatabaseSelection.attributeTypeMap;
    }
    constructor() {
    }
}
